module.exports = __webpack_public_path__ + "media/img/help_center/Student_Dashboard_02-587a23979f8318cd521653b74bac2cca.jpg";